import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";

import styles from "./ChatbotsTable.module.css";

export function ConversationsColumnLabel() {
  const t = useTranslations("chatbots-table");

  return (
    <span className={styles.conversationsColumnLabel}>
      {t("columns.conversations")}
      <Tooltip content={t("columns.conversations-tooltip")}>
        <TooltipFocusableTrigger>
          <Icon name="alertInfo" size="1em" color="TextWeakest" />
        </TooltipFocusableTrigger>
      </Tooltip>
    </span>
  );
}
